(() => {
  const inquiryUrl = summary => {
    const url = new URL('/pages/contact', window.location.origin);
    url.searchParams.set('view', 'group-order');
    url.searchParams.set('bundle', summary);
    return url.toString();
  };
  const groupForm = document.querySelector('#SunlifeGroupContact');
  if (groupForm) {
    const selected = new URL(location.href).searchParams.get('bundle');
    if (selected) {
      const value = selected.slice(0, 1500);
      const type = groupForm.querySelector('#GroupType');
      if (type) type.value = '組合商品詢問';
      const count = value.match(/(?:任選\s*)?(\d+)\s*(?:入|管)/);
      const quantity = groupForm.querySelector('#GroupQuantity');
      if (quantity && !quantity.value && count) quantity.value = count[1];
      const products = groupForm.querySelector('#GroupProducts');
      const body = groupForm.querySelector('#GroupBody');
      if (products && !products.value) products.value = value;
      if (body && !body.value) body.value = '想了解以下組合：\n' + value + '\n請協助確認庫存與配送方式。';
    }
  }
  const root = document.querySelector('[data-sunlife-bundles]');
  if (!root) return;
  const money = value => `NT$${value.toLocaleString('en-US', { maximumFractionDigits: 2 })}`;
  const isPartner = root.dataset.partnerPage === 'true';
  const storageKey = isPartner ? 'sunlife-partner-preview-v1' : 'sunlife-bundle-preview-v2';
  const acceptedCodes = ['RUN', 'KOL'];
  let partnerCode = '';
  root.querySelectorAll('[data-fixed-pack]').forEach(card => {
    const select = card.querySelector('[data-pack-size]');
    const updatePack = () => {
      const quantity = Number(select.value);
      const price = Number(quantity === 3 ? card.dataset.priceThree : card.dataset.priceSix);
      const image = card.querySelector('[data-pack-image]');
      const imageUrl = quantity === 3 ? card.dataset.imageThree : card.dataset.imageSix;
      if (image && imageUrl) {
        if (image.getAttribute('src') !== imageUrl) image.src = imageUrl;
        image.alt = `${card.dataset.packName} ${quantity} 管組合商品照`;
      }
      card.querySelector('[data-pack-price]').textContent = money(price);
      card.querySelector('[data-pack-unit]').textContent = `平均每管 ${price % quantity ? '約 ' : ''}${money(price/quantity)} · 共 ${quantity*20} 錠`;
      card.querySelector('[data-pack-inquiry]').href = inquiryUrl(`${card.dataset.packName} ${quantity}入組／${quantity*20}錠，整組${money(price)}（TWD方案預覽）`);
    };
    select.addEventListener('change', updatePack);
    updatePack();
  });
  root.querySelectorAll('[data-scenario-name]').forEach(card => {
    const products = [...card.querySelectorAll('.sl-scenario-products li')].map(item => item.textContent.trim()).join('、');
    card.querySelector('[data-scenario-inquiry]').href = inquiryUrl(`${card.dataset.scenarioName} 3入組：${products}，整組${money(Number(card.dataset.scenarioPrice))}（TWD方案預覽）`);
  });
  const rows = [...root.querySelectorAll('[data-pick-product]')];
  const tiers = [...root.querySelectorAll('[data-pick-tier]')];
  const categories = [...root.querySelectorAll('[data-pick-category-button]')];
  const action = root.querySelector('[data-pick-inquiry]');
  const labels = {basic:'基礎型',high:'高劑量'};
  let category = 'basic', target = 4, summary = '';
  const readQuantity = row => Number(row.querySelector('[data-pick-quantity]').value) || 0;
  const setQuantity = (row, value) => {
    const number = Number(value);
    row.querySelector('[data-pick-quantity]').value = String(Number.isFinite(number) ? Math.max(0, Math.min(15, Math.floor(number))) : 0);
  };
  const save = () => {
    try { sessionStorage.setItem(storageKey, JSON.stringify({category,target,partnerCode,quantities:Object.fromEntries(rows.map(row => [row.dataset.pickKey,readQuantity(row)]))})); } catch {}
  };
  const update = () => {
    const active = rows.filter(row => row.dataset.pickCategory === category);
    const total = active.reduce((sum,row) => sum + readQuantity(row),0);
    const tier = tiers.find(button => Number(button.dataset.pickTier) === target);
    const shopPrice = Number(tier.dataset[`${category}Price`]);
    const price = Number(tier.dataset[`${category}${partnerCode ? 'Partner' : 'Price'}`]);
    root.querySelector('[data-pick-heading]').textContent = `${labels[category]} · 任選 ${target} 入`;
    root.querySelector('[data-pick-count]').textContent = `已選 ${total}／${target} 管，${total>target ? `請減少 ${total-target} 管` : total===target ? '搭配完成' : `還差 ${target-total} 管`}`;
    root.querySelector('[data-pick-price]').textContent = money(price);
    root.querySelector('[data-pick-original]').textContent = money(partnerCode ? shopPrice : target*(category==='basic'?200:280));
    root.querySelector('[data-original-label]').textContent = partnerCode ? '官網價' : '原價';
    root.querySelector('[data-pick-unit]').textContent = `平均每管 ${price % target ? '約 ' : ''}${money(price/target)} · 共 ${target*20} 錠`;
    const selected = active.filter(row => readQuantity(row)>0);
    const list = root.querySelector('[data-pick-summary]');
    const contents = selected.length ? selected.map(row => `${row.dataset.pickName} × ${readQuantity(row)} 管`) : ['選擇配方與管數'];
    list.replaceChildren(...contents.map(text => {const li=document.createElement('li');li.textContent=text;return li;}));
    summary = `${labels[category]} 任選${target}入：${contents.join('、')}，整組${money(price)}${partnerCode ? `，測試優惠碼 ${partnerCode}` : ''}（TWD方案預覽）`;
    action.disabled = total!==target;
    rows.forEach(row => {
      row.hidden = row.dataset.pickCategory!==category;
      row.querySelector('[data-pick-plus]').disabled = total>=target || readQuantity(row)>=15;
      row.querySelector('[data-pick-minus]').disabled = readQuantity(row)===0;
    });
    tiers.forEach(button => {
      button.setAttribute('aria-pressed',String(Number(button.dataset.pickTier)===target));
      button.querySelector('[data-tier-price]').textContent=money(Number(button.dataset[`${category}${partnerCode ? 'Partner' : 'Price'}`]));
    });
    categories.forEach(button => button.setAttribute('aria-pressed',String(button.dataset.pickCategoryButton===category)));
    save();
  };
  rows.forEach(row => {
    row.querySelector('[data-pick-plus]').addEventListener('click',()=>{setQuantity(row,readQuantity(row)+1);update();});
    row.querySelector('[data-pick-minus]').addEventListener('click',()=>{setQuantity(row,readQuantity(row)-1);update();});
    row.querySelector('[data-pick-quantity]').addEventListener('input',event=>{setQuantity(row,event.target.value);update();});
  });
  categories.forEach(button => button.addEventListener('click',()=>{category=button.dataset.pickCategoryButton;update();}));
  tiers.forEach(button => button.addEventListener('click',()=>{target=Number(button.dataset.pickTier);update();}));
  root.querySelector('[data-pick-clear]').addEventListener('click',()=>{rows.filter(row=>row.dataset.pickCategory===category).forEach(row=>setQuantity(row,0));update();});
  action.addEventListener('click',()=>{if(!action.disabled) location.assign(inquiryUrl(summary));});
  const codeForm = root.querySelector('[data-partner-code-form]');
  const codeInput = root.querySelector('#PartnerCode');
  const codeStatus = root.querySelector('[data-code-status]');
  const codeRemove = root.querySelector('[data-code-remove]');
  const showCodeStatus = error => {
    if (!isPartner) return;
    codeStatus.textContent = error || (partnerCode ? `已套用 ${partnerCode}，以下顯示合作價。僅適用任選組，不與其他優惠疊加。` : '尚未套用優惠碼，以下顯示官網價。');
    codeInput.setAttribute('aria-invalid', String(Boolean(error)));
    codeRemove.hidden = !partnerCode;
  };
  if (codeForm) {
    codeForm.addEventListener('submit', event => {
      event.preventDefault();
      const code = codeInput.value.trim().toUpperCase();
      partnerCode = acceptedCodes.includes(code) ? code : '';
      codeInput.value = code;
      showCodeStatus(partnerCode ? '' : code ? '找不到這個測試碼，請使用 RUN 或 KOL。已恢復官網價。' : '請先輸入優惠碼。已恢復官網價。');
      update();
    });
    codeRemove.addEventListener('click', () => {partnerCode='';codeInput.value='';showCodeStatus();update();codeInput.focus();});
  }
  try {
    const saved=JSON.parse(sessionStorage.getItem(storageKey));
    if(saved && ['basic','high'].includes(saved.category) && [4,10,15].includes(saved.target) && saved.quantities && typeof saved.quantities==='object') {
      category=saved.category;target=saved.target;partnerCode=isPartner && acceptedCodes.includes(saved.partnerCode)?saved.partnerCode:'';rows.forEach(row=>setQuantity(row,saved.quantities[row.dataset.pickKey]));
    }
  } catch {}
  if (codeInput) codeInput.value=partnerCode;
  showCodeStatus();
  update();
})();

